export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14201.cab79297.jpg";